import { render, staticRenderFns } from "./shop-product-supplies.vue?vue&type=template&id=6d6a573e&"
import script from "./shop-product-supplies.vue?vue&type=script&lang=js&"
export * from "./shop-product-supplies.vue?vue&type=script&lang=js&"
import style0 from "./shop-product-supplies.vue?vue&type=style&index=0&id=6d6a573e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports